import { ReplenishDataSource } from '../replenish-worker/replenish-data/replenish-data.enums';
import { ReplenishTransferExpectQtyStrategy } from '../replenish-worker/replenish-strategy/replenish-transfer-expect-qty-strategy';
import { ReplenishTransferQOHStrategy } from '../replenish-worker/replenish-strategy/replenish-transfer-qoh-strategy';
import { ReplenishTransferZeroQOHStrategy } from '../replenish-worker/replenish-strategy/replenish-transfer-zero-qoh.strategy';
import { ReplenishConfigMap } from '../replenish-worker/replenish.types';
import {
  BTN_BULK_REPLENISH_ENDING_COUNT_OR_EXPECTED_QTY,
  BTN_BULK_REPLENISH_QOH,
  BTN_BULK_REPLENISH_ZERO_QOH,
  BTN_REPLENISH_ENDING_COUNT_OR_EXPECTED_QTY,
  BTN_REPLENISH_QOH,
  BTN_REPLENISH_ZERO_QOH,
} from '../transfer-replenish/transfer-replenish.constants';

const BULK_REPLENISH_CONFIG_MAPPING: ReplenishConfigMap = {
  [BTN_BULK_REPLENISH_ENDING_COUNT_OR_EXPECTED_QTY.caption as string]: {
    modalTitle:
      BTN_BULK_REPLENISH_ENDING_COUNT_OR_EXPECTED_QTY.caption as string,
    strategy: ReplenishTransferExpectQtyStrategy,
    afterInventory: [
      ReplenishDataSource.Qoh,
      ReplenishDataSource.PendingQty,
      ReplenishDataSource.StandWorksheet,
    ],
  },
  [BTN_BULK_REPLENISH_QOH.caption as string]: {
    modalTitle: BTN_BULK_REPLENISH_QOH.caption as string,
    strategy: ReplenishTransferQOHStrategy,
    afterInventory: [ReplenishDataSource.Qoh, ReplenishDataSource.PendingQty],
  },
  [BTN_BULK_REPLENISH_ZERO_QOH.caption as string]: {
    modalTitle: BTN_BULK_REPLENISH_ZERO_QOH.caption as string,
    strategy: ReplenishTransferZeroQOHStrategy,
    afterInventory: [ReplenishDataSource.Qoh, ReplenishDataSource.PendingQty],
  },
};

const REPLENISH_CONFIG_MAPPING: ReplenishConfigMap = {
  [BTN_REPLENISH_ENDING_COUNT_OR_EXPECTED_QTY.caption as string]: {
    modalTitle: BTN_REPLENISH_ENDING_COUNT_OR_EXPECTED_QTY.caption as string,
    strategy: ReplenishTransferExpectQtyStrategy,
    afterInventory: [ReplenishDataSource.StandWorksheet],
  },
  [BTN_REPLENISH_QOH.caption as string]: {
    modalTitle: BTN_REPLENISH_QOH.caption as string,
    strategy: ReplenishTransferQOHStrategy,
  },
  [BTN_REPLENISH_ZERO_QOH.caption as string]: {
    modalTitle: BTN_REPLENISH_ZERO_QOH.caption as string,
    strategy: ReplenishTransferZeroQOHStrategy,
  },
};

export { BULK_REPLENISH_CONFIG_MAPPING, REPLENISH_CONFIG_MAPPING };
